const LoginHeader = () => {
  return (
    <>
      <h1 className="text-center text-3xl font-bold text-gray-900">Welcome back</h1>

      <p className="text-center text-sm text-gray-500 mt-2 mb-8">Enter your email to sign in to your account</p>
    </>
  );
};

export default LoginHeader;
